(function(){
    const root = document.querySelector('[data-qna="detail"]');
    if (!root) return;

    const questionId = parseInt(root.getAttribute('data-question-id'), 10);
    const ajaxUrl    = root.getAttribute('data-ajax-url');
    const nonce      = root.getAttribute('data-nonce');

    const postAjax = (action, body = {}) =>
        fetch(ajaxUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: new URLSearchParams(Object.assign({ action, nonce }, body))
        }).then(r => r.json());

    // Accept / Unaccept
    root.addEventListener('click', (e) => {
        const btn = e.target.closest('.qna-accept-btn, .qna-unaccept-btn');
        if (!btn) return;
        const answer = btn.closest('[data-answer-id]');
        if (!answer) return;

        btn.disabled = true;
        postAjax('hellu_qna_accept_answer', {
            question_id: String(questionId),
            answer_id: String(answer.getAttribute('data-answer-id')),
            toggle: btn.classList.contains('qna-unaccept-btn') ? 'unaccept' : 'accept'
        }).then(res => {
            btn.disabled = false;
            if (!res || !res.success) { alert((res && res.data && res.data.message) || 'Error'); return; }
            window.location.reload();
        }).catch(()=>{ btn.disabled = false; alert('Network error'); });
    });

    // Composer
    const composer = root.querySelector('[data-composer="true"]');
    if (composer) {
        const textarea = composer.querySelector('.qna-answer-input');
        const draftBtn = composer.querySelector('.qna-save-draft');
        const pubBtn   = composer.querySelector('.qna-publish');
        const feedback = composer.querySelector('.qna-compose-feedback');

        const submit = (status) => {
            const content = (textarea.value || '').trim();
            if (!content) { feedback.textContent = 'Please write your answer.'; return; }
            draftBtn.disabled = pubBtn.disabled = true; feedback.textContent = 'Saving…';

            postAjax('hellu_qna_create_answer', { question_id: String(questionId), content, status })
                .then(res => {
                    draftBtn.disabled = pubBtn.disabled = false;
                    if (!res || !res.success) { feedback.textContent = (res && res.data && res.data.message) || 'Error'; return; }
                    window.location.reload();
                })
                .catch(() => { draftBtn.disabled = pubBtn.disabled = false; feedback.textContent = 'Network error'; });
        };

        draftBtn && draftBtn.addEventListener('click', () => submit('draft'));
        pubBtn && pubBtn.addEventListener('click', () => submit('publish'));
    }
})();
